exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dot_logo{min-height:2.5em;max-height:3.438em;opacity:.8;padding-left:.625em}.dot_logo.main{display:none}@media (min-width:48.063em){.dot_logo.main{display:block;position:fixed;z-index:10000;right:3%;bottom:.5%;margin:1.25em}}", "", {"version":3,"sources":["/app/src/components/Elements/DOTlogo/styles/logo.css"],"names":[],"mappings":"AAAA,UACE,iBAAkB,AAClB,mBAAoB,AACpB,WAAa,AACb,mBAAsB,CACvB,AAED,eACE,YAAc,CACf,AAED,4BACE,eACE,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,SAAU,AACV,WAAa,AACb,aAAe,CAChB,CACF","file":"logo.css","sourcesContent":[".dot_logo {\n  min-height: 2.5em;\n  max-height: 3.438em;\n  opacity: 0.8;\n  padding-left: 0.625em;\n}\n\n.dot_logo.main {\n  display: none;\n}\n\n@media (min-width: 48.063em) {\n  .dot_logo.main {\n    display: block;\n    position: fixed;\n    z-index: 10000;\n    right: 3%;\n    bottom: 0.5%;\n    margin: 1.25em;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Elements/DOTlogo/styles/logo.css
// module id = 1471
// module chunks = 0